@if (!isLoadingNewWorkspace()) {
<section class="chat-page">
  @if (ui().showSidebar && !ui().isFullScreenVideoCall) {
  <aside class="chat-page__sidebar">
    <ngx-sidebar>
      <ngx-workspace-drawer workspaces></ngx-workspace-drawer>
      <ng-content select="[lang-selector]" lang-selector></ng-content>
    </ngx-sidebar>
  </aside>
  } @if ((ui().showProfile || ui().showChannels) && !ui().isFullScreenVideoCall) {
  <section
    [ngClass]="{
      'border-resize': resizeService.isDragging(),
      dragging: resizeService.isDragging(),
      'chat-page__channels': !ui().showChannel,
      'chat-page__profile-channels': ui().showChannel
    }"
    [style]="{ width: ui().showChannel ? resizeService.channelsWidth() + 'px' : 'calc(100% - 8px)' }">
    <div class="resize" (mousedown)="onResizeStart($event)" [class.dragging]="resizeService.isDragging()"></div>
    @if (ui().showProfile) {
    <div class="chat-page__profile" id="profile">
      <ngx-profile>
        <ngx-profile-actions actions (settingsEvent)="goSettings()"></ngx-profile-actions>
      </ngx-profile>
    </div>
    } @if (ui().showChannels) {
    <div class="chat-page__channels-list">
      <ngx-channels [phoneNumber]="phoneNumber"></ngx-channels>
    </div>
    }
  </section>
  } @if (ui().showChannel) {
  <section class="chat-page__chat">
    <ngx-channel (orderIdEvent)="emitOrderIdEvent($event)"></ngx-channel>
  </section>
  }
</section>
} @else {
<div class="loading">
  <img [src]="messagingIconUrl" />
</div>
}
